var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CodeEditor',{directives:[{name:"debounce",rawName:"v-debounce:1000ms",value:((v) => _vm.updateProp(v)),expression:"(v) => updateProp(v)",arg:"1000ms"}],staticClass:"parameter-code-editor",attrs:{"value":_vm.value,"width":"100%","font_size":"14px","copy_code":false,"languages":[['html', 'HTML']]}})
}
var staticRenderFns = []

export { render, staticRenderFns }